import 'regenerator-runtime/runtime';
import {
  call, put, fork, takeEvery,
} from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { CONVERSATION_UPLOAD_FILE_SUCCESS } from 'constants/redux/conversation';
import { UPDATE_COTTAGE_SUCCESS } from 'constants/redux/cottage';
import { conversationUploadFileIdle } from 'actions/conversation';
import * as constants from '../constants';
import * as actions from '../actions';
import { updateCottageIdle } from '../actions/cottage';

function* fetchUserSelfSuccess() {
  yield call(delay, 4000);
  yield put(actions.fetchUserSelfIdle());
}

function* listCottageImagesSuccess() {
  yield call(delay, 4000);
  yield put(actions.listCottageImagesIdle());
}

function* reorderCottageImagesSuccess() {
  yield call(delay, 4000);
  yield put(actions.reorderCottageImagesIdle());
}

function* removeCottageImagesSuccess() {
  yield call(delay, 4000);
  yield put(actions.removeCottageImagesIdle());
}

function* updateCottageImageSuccess() {
  yield call(delay, 4000);
  yield put(actions.updateCottageImageIdle());
}

function* fetchRoomSuccess() {
  yield call(delay, 4000);
  yield put(actions.fetchRoomIdle());
}

function* fetchCottageImageSuccess() {
  yield call(delay, 4000);
  yield put(actions.fetchCottageImageIdle());
}

function* postLoginSuccess() {
  yield call(delay, 4000);
  yield put(actions.postLoginIdle());
}

function* postLogoutSuccess() {
  yield call(delay, 4000);
  yield put(actions.postLogoutIdle());
}

function* cottageImageUploadSuccess() {
  yield call(delay, 4000);
  yield put(actions.cottageImageUploadIdle());
}

function* generateImagePreviewSuccess() {
  yield call(delay, 4000);
  yield put(actions.generateImagePreviewIdle());
}

function* updateCalendarSuccess() {
  yield call(delay, 4000);
  yield put(actions.updateCalendarIdle());
}

function* generateCottageSettingsSuccess() {
  yield call(delay, 4000);
  yield put(actions.updateCottageSettingsIdle());
}

function* generateUpdateUserSuccess() {
  yield call(delay, 4000);
  yield put(actions.updateUserIdle());
}

function* conversationUploadFileSuccess() {
  yield call(delay, 500);
  yield put(conversationUploadFileIdle());
}

function* postBookingSuccess() {
  yield call(delay, 4000);
  yield put(actions.postBookingIdle());
}

function* uploadIDProofSuccess() {
  yield call(delay, 4000);
  yield put(actions.uploadIDProofIdle());
}

function* generateUpdateCottageSuccess() {
  yield call(delay, 1000);
  yield put(updateCottageIdle());
}

function* putBookingSuccess() {
  yield call(delay, 4000);
  yield put(actions.putBookingIdle());
}

function* deleteUserFailure() {
  yield call(delay, 4000);
  yield put(actions.deleteUserIdle());
}

export default [
  fork(takeEvery, constants.FETCH_USER_SELF_SUCCSSS, fetchUserSelfSuccess),
  fork(takeEvery, constants.LIST_COTTAGE_IMAGES_SUCCESS, listCottageImagesSuccess),
  fork(takeEvery, constants.REORDER_COTTAGE_IMAGES_SUCCESS, reorderCottageImagesSuccess),
  fork(takeEvery, constants.REMOVE_COTTAGE_IMAGES_SUCCESS, removeCottageImagesSuccess),
  fork(takeEvery, constants.UPDATE_COTTAGE_IMAGE_SUCCESS, updateCottageImageSuccess),
  fork(takeEvery, constants.FETCH_ROOM_SUCCESS, fetchRoomSuccess),
  fork(takeEvery, constants.FETCH_COTTAGE_IMAGE_SUCCESS, fetchCottageImageSuccess),
  fork(takeEvery, constants.POST_LOGIN_SUCCESS, postLoginSuccess),
  fork(takeEvery, constants.POST_LOGOUT_SUCCESS, postLogoutSuccess),
  fork(takeEvery, constants.COTTAGE_IMAGE_UPLOAD_SUCCESS, cottageImageUploadSuccess),
  fork(takeEvery, constants.GENERATE_IMAGE_PREVIEW_SUCCESS, generateImagePreviewSuccess),
  fork(takeEvery, constants.UPDATE_CALENDAR_SUCCESS, updateCalendarSuccess),
  fork(takeEvery, constants.UPDATE_COTTAGE_SETTINGS_SUCCESS, generateCottageSettingsSuccess),
  fork(takeEvery, UPDATE_COTTAGE_SUCCESS, generateUpdateCottageSuccess),
  fork(takeEvery, constants.UPDATE_USER_SUCCESS, generateUpdateUserSuccess),
  fork(takeEvery, CONVERSATION_UPLOAD_FILE_SUCCESS, conversationUploadFileSuccess),
  fork(takeEvery, constants.POST_BOOKING_SUCCESS, postBookingSuccess),
  fork(takeEvery, constants.UPLOAD_IDPROOF_SUCCESS, uploadIDProofSuccess),
  fork(takeEvery, constants.PUT_BOOKING_SUCCESS, putBookingSuccess),
  fork(takeEvery, constants.DELETE_USER_FAILURE, deleteUserFailure),
];
